import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const AlternateThumbnails = ({thumbnails, selected, setThumbnail}) => { 
    return (
        <div className="alternate-thumbnails">
          {thumbnails.map(x =>
              <img
                onClick={() => setThumbnail(x)}
                src={"/ipfs/" + x}
                className={selected === x ? "pushable alternate-thumbnail selected" : "pushable alternate-thumbnail"}/>)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlternateThumbnails);
